import { HttpInterceptorFn } from "@angular/common/http";
import { CookieService } from "@main/cookie/cookie.service";

/**
 * This interceptor allows developers to visit the application from
 * the port where front end part launched. He changes requests to API by adding
 * the part which leads to the back end origin. Thus front end becomes a root of
 * the site that is required by some technologies like PWA. Specify corresponding
 * origins for front and back parts into "frontEndOrigin" and "backEndOrigin" fields.
 * Ensure that back end allows Cross-Origin Resource Sharing (CORS).
 * */

const frontEndOrigin = "http://localhost:4200"; // Origin where the front-end server runs.
const backEndOrigin = "http://localhost:50815"; // Origin where the back-end server runs.
const apiUrlSegment = "api/"; // A segment within an URL that uniquely identifies an API request.

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.url.includes(apiUrlSegment) && location.origin == frontEndOrigin) {
        let headers = req.headers;

        const requestToken = CookieService.GetCookie("XSRF-REQUEST-TOKEN");
        if (requestToken) {
            headers = headers.set("X-XSRF-TOKEN", requestToken);
        }

        req = req.clone({
            url: `${backEndOrigin}/${req.url}`,
            headers: headers,
            withCredentials: true
        });
    }

    return next(req);
};
